import { render, staticRenderFns } from "./CompTabelaCDASelecionadasProtesto.vue?vue&type=template&id=65eaf9e6&scoped=true&"
import script from "./CompTabelaCDASelecionadasProtesto.vue?vue&type=script&lang=js&"
export * from "./CompTabelaCDASelecionadasProtesto.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaCDASelecionadasProtesto.vue?vue&type=style&index=0&id=65eaf9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eaf9e6",
  null
  
)

export default component.exports